import { render, staticRenderFns } from "./DashboardFolder.vue?vue&type=template&id=d76a3a44&scoped=true&"
import script from "./DashboardFolder.vue?vue&type=script&lang=js&"
export * from "./DashboardFolder.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFolder.vue?vue&type=style&index=0&id=d76a3a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76a3a44",
  null
  
)

export default component.exports